const EVENT_CALLBACK_DELAY = 300;

export const commonOfferEventHandlers = {
    'add-to-cart-click': 'emitAddToCartClick',
    'remove-from-cart-click': 'emitRemoveFromCartClick',
    'add-to-favourites-click': 'emitAddToFavouritesClick',
    'remove-from-favourites-click': 'emitRemoveFromFavouritesClick',
    'add-to-compare-click': 'emitAddToCompareClick',
    'remove-from-compare-click': 'emitRemoveFromCompareClick',
};

export const commonSearchResultsWrapperEventHandlers = {
    'autocomplete-search': 'emitAutocompleteSearch',
    'params-search': 'emitParamsSearch',
    'search-image': 'emitSearchImage',
    'search-input-change': 'emitSearchInputChange',
    'offer-click': 'emitOfferClick',
    'age-confirmed': 'emitAgeConfirmed',
    'filters-change': 'emitFiltersChange',
    'filter-click': 'emitFilterClick',
    'sort-change': 'emitSortChange',
    'result-tab-click': 'emitResultTabClick',
    'result-sort-click': 'emitResultSortClick',
    'reset-filters': 'emitResetFilters',
    'reset-query': 'emitResetQuery',
    'navigate-category': 'emitNavigateCategory',
    'navigate-page-next': 'emitNavigatePageNext',
    'navigate-page-prev': 'emitNavigatePagePrev',
    'button-image-click': 'emitButtonImageClick',
    'page-reload': 'emitPageReload',
};

export function mapHandlers(context, handlers) {
    const result = {};
    for (const [event, method] of Object.entries(handlers)) {
        result[event] = context[method];
    }
    return result;
}

export default {
    methods: {
        /**
         * ============================================
         * События товара (offer)
         * ============================================
         */
        emitAddToCart(offer) {
            this.$emit('add-to-cart', offer);
        },
        emitAddToCartClick(event) {
            this.$emit('add-to-cart-click', event);
        },
        emitRemoveFromCartClick(event) {
            this.$emit('remove-from-cart-click', event);
        },
        emitAddToFavouritesClick(event) {
            this.$emit('add-to-favourites-click', event);
        },
        emitRemoveFromFavouritesClick(event) {
            this.$emit('remove-from-favourites-click', event);
        },
        emitAddToCompareClick(event) {
            this.$emit('add-to-compare-click', event);
        },
        emitRemoveFromCompareClick(event) {
            this.$emit('remove-from-compare-click', event);
        },

        /**
         * ============================================
         * События поиска
         * ============================================
         */
        emitSearchAll() {
            this.$emit('search-all');
        },
        emitParamsSearch(params) {
            this.$emit('params-search', params);
        },
        emitAutocompleteSearch(value) {
            this.$emit('autocomplete-search', value);
        },
        emitHandleSearch() {
            this.$emit('handle-search');
        },
        emitVoiceSearch(isVoiceSearch) {
            this.$emit('voice-search', isVoiceSearch);
        },
        emitSearchImage(event) {
            this.$emit('search-image', event);
        },

        /**
         * ============================================
         * События подсказок (completions)
         * ============================================
         */
        emitCategoryClick(value) {
            this.$emit('category-click', value);
        },
        emitSpecialOffersClick(value) {
            this.$emit('special-offers-click', value);
        },
        emitSuggestionsClick(value) {
            this.$emit('suggestions-click', value);
        },
        emitBrandClick(value) {
            this.$emit('brand-click', value);
        },
        emitPopularClick(value) {
            this.$emit('popular-click', value);
        },
        emitCompletionsOpen(params) {
            this.$emit('completions-open', params);
        },
        emitCompletionsClose() {
            this.$emit('completions-close');
        },
        emitRemoveHistory(params) {
            this.$emit('remove-history', params);
        },
        emitOfferClick(event) {
            this.$emit('offer-click', event);
        },

        /**
         * ============================================
         * События фильтров
         * ============================================
         */
        emitFiltersChange(filters) {
            this.$emit('filters-change', filters);
        },
        emitToggleFilters(value) {
            this.$emit('toggle-filters', value);
        },
        emitFilterClick(params) {
            this.$emit('filter-click', params);
        },
        emitSortChange(params) {
            this.$emit('sort-change', params);
        },
        emitResultSortClick(params) {
            this.$emit('result-sort-click', params);
        },
        emitResetFilters() {
            this.$emit('reset-filters');
        },

        /**
         * ============================================
         * События изображений
         * ============================================
         */
        emitButtonImageClick(event) {
            this.$emit('button-image-click', { type: 'buttonImageClick', event });
        },
        emitImageSearchButtonSelectFileClick(value) {
            this.$emit('image-search-button-select-file-click', value);
        },
        emitImageSearchUseCorrectLinkClick(value) {
            this.$emit('image-search-use-correct-link-click', value);
        },
        emitImageSearchUseIncorrectLinkClick(value) {
            this.$emit('image-search-use-incorrect-link-click', value);
        },
        emitImageSearchButtonSearchClick(value) {
            this.$emit('image-search-button-search-click', value);
        },

        /**
         * ============================================
         * Прочие события
         * ============================================
         */
        emitSearchInputChange(params) {
            this.$emit('search-input-change', params);
        },
        emitSearchInputBlur() {
            this.$emit('search-input-blur');
        },
        emitSearchInputFocus() {
            this.$emit('search-input-focus');
        },
        emitSearchInputEnter(params) {
            this.$emit('search-input-enter', params);
        },
        emitSearchClick(value) {
            this.$emit('search-click', value);
        },
        emitResetQuery() {
            this.$emit('reset-query');
        },
        emitDeleteAllText(value) {
            this.$emit('delete-all-text', value);
        },
        emitNavigatePageNext() {
            this.$emit('navigate-page-next');
        },
        emitNavigatePagePrev() {
            this.$emit('navigate-page-prev');
        },
        emitNavigateCategory(params) {
            this.$emit('navigate-category', params);
        },
        emitViewInCategoryClick(params) {
            this.$emit('view-in-category-click', params);
        },
        emitResultCategoryClick(params) {
            this.$emit('result-category-click', params);
        },
        emitPageReload() {
            this.$emit('page-reload');
        },
        emitAgeConfirmed() {
            this.$emit('age-confirmed');
        },
        emitSearchPopupFetchCategories() {
            this.$emit('search-popup-fetch-categories');
        },
        emitButtonEverywhereClick(value) {
            this.$emit('button-everywhere-click', value);
        },
        emitRubricatorCategoryClick(value) {
            this.$emit('rubricator-category-click', value);
        },
        emitPreviewShowAllClick(value) {
            this.$emit('preview-show-all-click', value);
        },
        emitResultTabClick(event) {
            this.$emit('result-tab-click', event);
        },
        emitClickAdult(event) {
            this.$emit('click-adult', event);
        },
        emitSearchPopupClose() {
            this.$emit('search-popup-close');
        },
        emitClickOutsideWidget(event) {
            this.$emit('click-outside-widget', event);
        },
        emitPreviewTabClick(value) {
            this.$emit('preview-tab-click', value);
        },
        emitCloseWidgetClick(query, clickType, event) {
            this.$emit('close-widget-click', {
                type: 'closeWidget',
                query,
                customEventType: clickType,
                event,
            });
        },
        emitHandleTagsClick(args) {
            this.onSearchInputAction('search-input-change', args);
        },
        emitToggleImagePicker(params) {
            this.toggleImageSearch(params);
        },

        /**
         * ============================================
         * Вспомогательные методы
         * ============================================
         */
        onSearchInputAction(eventName, params) {
            let afterEventCallback = null;
            switch (eventName) {
            case 'search-input-change':
                this.emitSearchInputChange(params);
                break;
            case 'handle-search':
                this.toggleFilters(false);
                this.emitHandleSearch();
                break;
            case 'toggle-image-picker':
                this.toggleImageSearch(params);
                break;
            case 'popup-close':
                this.emitSearchPopupClose();
                break;
            case 'search-input-blur':
                this.emitSearchInputBlur();
                break;
            case 'search-input-focus':
                this.emitSearchInputFocus();
                break;
            case 'search-input-enter':
                this.emitSearchInputEnter(params);
                break;
            case 'reset-query':
                this.resetImage();
                this.emitResetQuery(params);
                break;
            case 'add-to-cart':
                this.emitAddToCart(params);
                break;
            case 'remove-history':
                this.emitRemoveHistory();
                break;
            default:
                afterEventCallback = () => {
                    this.showSearch = true;
                };
                this.$emit(eventName, params);
            }
            this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });

            if (afterEventCallback) {
                setTimeout(afterEventCallback, EVENT_CALLBACK_DELAY);
            }
        },
    },
};
